export const formatDateBox = (editorOptions?: Record<string, any>): Record<string, any> => {
  let dateEditorOptions = {};
  if (editorOptions?.type === 'date' || editorOptions?.type === 'datetime') {
    const defaultDisplayFormat =
      editorOptions?.type === 'date' ? 'shortDate' : 'shortDateshortTime';
    const defaultMinValue =
      editorOptions?.type === 'date' ? new Date(1900, 0, 1) : new Date(1900, 0, 1, 0, 0);
    dateEditorOptions = {
      ...dateEditorOptions,
      displayFormat: editorOptions.displayFormat || defaultDisplayFormat,
      min: editorOptions.min || defaultMinValue,
      acceptCustomValue: false,
      openOnFieldClick: true,
    };
  }

  return { ...editorOptions, ...dateEditorOptions };
};
